<template>
    <transition name="fade">
        <div id="tablet">
            <div class="tips-action">
                Cliquez sur la tablette
                <img src="@/assets/svg/hand_up.svg"
                     alt="Symbole en forme de main indiquant l'endroit où l'utilisateur dois intéragir">
            </div>
            <div class="transparent-action" @click="emit"></div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'Tablet',
        methods: {
            emit() {
                this.state = false
                setTimeout(function () {
                    $('#skip').show()
                }, 3000);
                this.$emit('go')
            }
        },
        data() {
            return {
                state: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    #tablet {
        .tips-action {
            text-align: center;
            font-size: 1.875rem;
            color: #fff;
            font-family: 'Roboto Condensed', sans-serif;
            position: absolute;
            width: 23%;
            height: 28%;
            top: 50%;
            left: 70%;
            img {
                width: 17%;
                height: auto;
                display: block;
                margin: 20px auto auto auto;
                animation: hand-animation 700ms ease-in-out infinite alternate;
            }
            @keyframes hand-animation {
                0% {
                    transform: translateY(0px);
                }
                100% {
                    transform: translateY(20px);
                }
            }
        }

        .transparent-action {
            position: absolute;
            width: 13%;
            height: 13%;
            top: 79%;
            left: 76%;
            background-color: transparent;
            transform: skew(60deg, -15deg);
            cursor: pointer;
        }
    }

</style>
